import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { DeleteIcon, EditIcons } from "../../../assets/icons-components/Icons";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import TableStatusRow from "../../../components/TableStatusRow/TableStatusRow";
import StatusChip from "../../../components/StatusChip/StatusChip";

const ADD_DEVICE_TABLE_COLUMN_COUNT = 6;

const AddDeviceTable = ({
  rows,
  isLoading,
  fetchError,
  onRetry,
  onEdit,
  onDelete,
  onUploadJson,
  onViewDevice,
  page,
  rowsPerPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <div className="mainadd_container">
    <div className="mainadd_container_table">
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell>SL NO</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Device UDI</TableCell>
              <TableCell>Number of Slots</TableCell>
              <TableCell>Assigned Health Professional</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length === 0 ? (
              <TableStatusRow
                colSpan={ADD_DEVICE_TABLE_COLUMN_COUNT}
                loading={isLoading}
                error={fetchError}
                onRetry={onRetry}
                emptyMessage="No devices found"
              />
            ) : (
              rows.map((row, index) => (
                  <TableRow key={row.deviceId}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell style={{ fontWeight: 600, color: "#104581" }}>
                      <span
                        role="button"
                        tabIndex={0}
                        className="device-name-link"
                        onClick={() => onViewDevice(row)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") onViewDevice(row);
                        }}
                      >
                        {row.deviceName || "-"}
                      </span>
                    </TableCell>
                    <TableCell>
                      <CustomTooltip title={row.deviceUdi || "-"}>
                        <span className="single-line" style={{ display: "inline-block", maxWidth: "100%" }}>
                          {row.deviceUdi || "-"}
                        </span>
                      </CustomTooltip>
                    </TableCell>
                    <TableCell>{row.numberOfSlots ?? "-"}</TableCell>
                    <TableCell>
                      <StatusChip
                        label={row.healthProfessionalName || "Unassigned"}
                        tone={row.healthProfessionalName ? "positive" : "neutral"}
                      />
                    </TableCell>
                    <TableCell>
                      <div
                        className="table_icons"
                        style={{ display: "flex", gap: "15px" }}
                      >
                        <CustomTooltip title="Edit">
                          <IconButton
                            aria-label="edit"
                            onClick={() => onEdit(row)}
                          >
                            <EditIcons />
                          </IconButton>
                        </CustomTooltip>
                        <CustomTooltip title="Upload JSON">
                          <IconButton
                            aria-label="upload json"
                            onClick={() => onUploadJson(row)}
                          >
                            <UploadFileIcon sx={{ color: "#104581" }} />
                          </IconButton>
                        </CustomTooltip>
                        <CustomTooltip title="Delete">
                          <IconButton
                            aria-label="delete"
                            onClick={() => onDelete(row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CustomTooltip>
                      </div>
                    </TableCell>
                  </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
    <div className="mainadd_container_pagination">
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  </div>
);

export default AddDeviceTable;
